import { FunctionComponent, useEffect, useState } from 'react'
import styles from './childrenTable.module.scss'
import { Close, Create } from '@mui/icons-material'
import { TableCell, TableRow } from '@mui/material'
import InfoChildDialog from '../Dialog/infoChild'
import { useTranslation } from 'react-i18next'
import Desktop from '@/modules/desktopMobile/desktop'
import { Child } from '@/types/Child'
import DeleteIcon from '@mui/icons-material/Delete'
import ConfirmDetachChild from '../Dialog/confirmDetachChild'

interface BodyCellProps {
    child: Child
    getParentInfos: () => void
    isNanny: boolean
    isBelgian: boolean
}

type DayPreference = {
    day: string
    timeline: 'morning' | 'afternoon' | 'allDay'
}

const TableBodyCell: FunctionComponent<BodyCellProps> = ({
    child,
    getParentInfos,
    isNanny,
    isBelgian
}: BodyCellProps) => {
    const { t } = useTranslation()

    const [daysAllDay, setAllDay] = useState<Array<DayPreference>>([])

    useEffect(() => {
        const days: Array<DayPreference | undefined> = []
        days.push(defineDayTimeline(child.mon, t('monday')))
        days.push(defineDayTimeline(child.tue, t('tuesday')))
        days.push(defineDayTimeline(child.wed, t('wednesday')))
        days.push(defineDayTimeline(child.thu, t('thursday')))
        days.push(defineDayTimeline(child.fri, t('friday')))
        days.push(defineDayTimeline(child.sat, t('saturday')))
        days.push(defineDayTimeline(child.sun, t('sunday')))

        const filteredDays: DayPreference[] = days.filter((day): day is DayPreference => day !== undefined)
        setAllDay(filteredDays)
    }, [child])

    function defineDayTimeline(day: 0 | 1 | 2 | 3, t: string): DayPreference | undefined {
        switch (day) {
            case 1:
                return { day: t, timeline: 'morning' }
            case 2:
                return { day: t, timeline: 'afternoon' }
            case 3:
                return { day: t, timeline: 'allDay' }
            default:
                break
        }
    }

    const [openEditDialog, setOpenEditDialog] = useState<boolean>(false)

    const [openDetachDialog, setOpenDetachDialog] = useState<boolean>(false)

    return (
        <TableRow>
            <TableCell className={styles.InformationsCell} sx={{ width: isBelgian ? '25%' : '35%' }} align={'left'}>
                <p className={styles.Firstname}>{child.firstname}</p>
                <p className={styles.Line}></p>
                <p className={styles.Birthdate}> {child.birthdate.replace(/-/g, '/')} </p>
            </TableCell>
            {isBelgian && (
                <TableCell className={styles.InformationsCell} sx={{ width: '25%' }} align={'left'}>
                    {child.preRegistrationBelgium ? (
                        <p className={styles.Firstname}>{child.preRegistrationBelgium}</p>
                    ) : (
                        <Close className={styles.Icon} />
                    )}
                </TableCell>
            )}
            <Desktop>
                <TableCell className={styles.PreferenceCell} sx={{ width: isBelgian ? '35%' : '50%' }} align={'left'}>
                    {daysAllDay.length > 0 ? (
                        <p className={styles.Days}>
                            {daysAllDay.map((day: DayPreference | undefined, index) => (
                                <span key={index} className={styles.DayWithColor}>
                                    {day ? (
                                        <>
                                            {day.day} (<span className={styles.Timeline}>{t(day.timeline)}</span>)
                                            {index < daysAllDay.length - 1 && ', '}
                                        </>
                                    ) : null}
                                </span>
                            ))}
                        </p>
                    ) : (
                        <p className={styles.NoDay}>{t('noPreferences')}</p>
                    )}
                </TableCell>
            </Desktop>
            <TableCell className={styles.ActionsCell} sx={{ width: '15%' }} align={'center'}>
                <Create onClick={() => setOpenEditDialog(true)} className={styles.Icon} />
                {isNanny && <DeleteIcon className={styles.Icon} onClick={() => setOpenDetachDialog(true)} />}
            </TableCell>
            <InfoChildDialog
                child={child}
                getParent={getParentInfos}
                handleClose={() => setOpenEditDialog(false)}
                open={openEditDialog}
                isBelgian={isBelgian}
                signUpAutolink={false}
            />
            <ConfirmDetachChild
                open={openDetachDialog}
                handleClose={() => setOpenDetachDialog(false)}
                childName={child.firstname}
                childId={child.id}
                getParentInfos={getParentInfos}
            />
        </TableRow>
    )
}

export default TableBodyCell
